e
<template>
    <div class="mx-auto w-full mb-5">
        <div class="page-header">
            <PageBreadcrumb>
                <template #actions>
                    <BillingTenantSelector :only-current-tenant="true" :on-select="onSelectedTenantChange" />
                </template>
            </PageBreadcrumb>
        </div>
        <!-- <dl
                class="mt-5 grid grid-cols-1 divide-y divide-border overflow-hidden rounded-lg bg-card shadow-sm lg:grid-cols-1 lg:divide-x lg:divide-y-0">
                <div class="p-4 px-6">
                    <div class="flex justify-between items-center">
                        <div>
                            <dt class="text-base font-normal text-muted-foreground">Usage this billing cycle</dt>
                            <dd class="mt-1 flex items-baseline gap-2 md:block lg:flex">
                                <div class="flex items-baseline text-2xl font-medium text-chart-1">
                                    $430
                                    <span class="ml-2 text-sm font-medium text-muted-foreground">( previous month $365.5 )</span>
                                </div>

                                <Badge variant="default" class="md:mt-2 lg:mt-0">
                                    <ArrowUpIcon class="mr-0.5 shrink-0 self-center h-4 w-4 text-chart-1" />
                                    <span class="sr-only"> Increased by </span>
                                    12%
                                </Badge>
                            </dd>
                        </div>
                        <button
                            aria-label="button"
                            type="button"
                            class="rounded-md bg-primary px-3 py-2 text-sm font-medium text-white shadow-xs hover:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent">
                            Billing
                        </button>
                    </div>
                </div>
                <div class="p-4 px-6">
                    <div class="flex justify-between items-center">
                        <div>
                            <dt class="text-base font-normal text-muted-foreground">Services</dt>
                            <dd class="mt-1 flex items-baseline gap-2 md:block lg:flex">
                                <div class="flex items-baseline text-2xl font-medium text-chart-1">
                                    2
                                    <span class="ml-2 text-sm font-medium text-chart-1">( 2/3 running )</span>
                                </div>
                            </dd>
                        </div>
                        <button
                            aria-label="button"
                            type="button"
                            class="rounded-md bg-primary px-3 py-2 text-sm font-medium text-white shadow-xs hover:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent">
                            Manage
                        </button>
                    </div>
                </div>
            </dl> -->
        <div>
            <div>
                <div class="flex justify-between items-end mb-3">
                    <h3 class="font-semibold">Usage</h3>
                </div>
                <div class="mt-5 space-y-6">
                    <!-- Billable Data - Prominently displayed first -->
                    <div class="bg-primary/5 border border-primary/20 rounded-lg p-4">
                        <div class="flex items-center justify-between mb-3">
                            <h4 class="text-lg font-semibold text-primary">Billable Data</h4>
                            <div class="text-xs text-muted-foreground bg-muted/50 px-2 py-1 rounded">
                                Maximum of inbound and outbound data
                            </div>
                        </div>
                        <div class="grid grid-cols-1 gap-3 lg:grid-cols-4 xl:grid-cols-6">
                            <StatCard
                                v-for="stat in usageStats.billable"
                                :key="stat.id"
                                :title="stat.name"
                                :value="stat.value"
                                :loading="stat.loading" />
                        </div>
                    </div>
                    <!-- Inbound Data -->
                    <div>
                        <h4 class="text-sm font-medium text-muted-foreground mb-3">Inbound Data</h4>
                        <div class="grid grid-cols-1 gap-3 lg:grid-cols-4 xl:grid-cols-6">
                            <StatCard
                                v-for="stat in usageStats.inbound"
                                :key="stat.id"
                                :title="stat.name"
                                :value="stat.value"
                                :loading="stat.loading" />
                        </div>
                    </div>
                    <!-- Outbound Data -->
                    <div>
                        <h4 class="text-sm font-medium text-muted-foreground mb-3">Outbound Data</h4>
                        <div class="grid grid-cols-1 gap-3 lg:grid-cols-4 xl:grid-cols-6">
                            <StatCard
                                v-for="stat in usageStats.outbound"
                                :key="stat.id"
                                :title="stat.name"
                                :value="stat.value"
                                :loading="stat.loading" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex justify-between items-end mb-3 mt-10">
                <h3 class="font-semibold">Billing Metrics</h3>
            </div>

            <Card class="bg-sidebar-primary-foreground">
                <CardHeader>
                    <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                        <TimeRangeFilter
                            :model-value="convertFilterKeyToTimeRangeValue(selectedBillingTimeseriesDateFilter?.key || 'last24h')"
                            :disabled="timeseriesLoading || globalSourceConfigsLoading || globalDestinationConfigsLoading"
                            :include-live-option="false"
                            :include-all-time-option="false"
                            :include-date-options="false"
                            :include-short-ranges="false"
                            :hide-options="[]"
                            @update:model-value="onTimeRangeChange" />
                        <div class="flex items-center justify-end min-w-0 sm:max-w-xs sm:w-auto w-full">
                            <MultiSelect
                                v-model="selectedBillingMetricKeys"
                                :options="listOfBillingMetrics"
                                :placeholder="
                                    timeseriesLoading ? 'Loading...' : listOfBillingMetrics?.length ? 'Select metrics' : 'No metrics available'
                                "
                                :disabled="timeseriesLoading || !listOfBillingMetrics?.length"
                                :option-label="'name'"
                                :track-by="'key'"
                                :show-tags="false"
                                :enable-refresh="true"
                                @refresh="fetchBillingTimeseries(selectedBillingTimeseriesDateFilter.value, selectedTenantIds?.value || [])" />
                        </div>
                    </div>
                </CardHeader>
                <CardContent class="pt-0">
                    <HighChart
                        :chart-options="chartOptions"
                        :loading="timeseriesLoading || globalSourceConfigsLoading || globalDestinationConfigsLoading" />
                </CardContent>
            </Card>

            <div class="mt-10">
                <div class="flex justify-between items-center mb-6">
                    <h3 class="font-semibold">Connector Usage</h3>
                </div>

                <!-- Sources Table Section -->
                <div class="space-y-4 bg-card rounded-lg border p-4">
                    <!-- Sources Table Header -->
                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-3">
                            <h4 class="text-lg font-medium">Sources - Inbound</h4>
                        </div>
                        <div class="flex items-center gap-4">
                            <ActionMenu
                                variant="row"
                                :show-export-usage="true"
                                :loading="sourcesExportLoading"
                                :disable-export-usage="
                                    sourcesTableDataLoading ||
                                    globalSourceConfigsLoading ||
                                    sourcesExportLoading
                                "
                                :buttons-size="'xs'"
                                @export-usage="downloadSourcesUsage(selectedTenantIds?.value || [])" />
                            <div class="flex items-center gap-2">
                                <span class="text-sm text-muted-foreground">Show table:</span>
                                <label for="show-sources" class="flex items-center gap-2">
                                    <Checkbox v-model="showSourcesTable" id="show-sources" />
                                    <span class="text-sm">Visible</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- Sources Controls -->
                    <div v-if="showSourcesTable" class="space-y-4">
                        <!-- Search and Column Selection -->
                        <div class="flex flex-col sm:flex-row gap-4">
                            <div class="flex-1">
                                <SearchInput
                                    :loading="sourcesTableDataLoading"
                                    placeholder="Search sources..."
                                    @search="
                                        (input) => {
                                            sourcesSearchQuery = input;
                                            onSourcesSearchInput(input);
                                        }
                                    " />
                            </div>
                            <div class="min-w-64">
                                <MultiSelect
                                    v-model="selectedSourcesColumns"
                                    :options="sourcesColumnOptions"
                                    placeholder="Select columns"
                                    :show-tags="true"
                                    :show-select-all="true" />
                            </div>
                        </div>
                    </div>

                    <!-- Sources Table -->
                    <div v-if="showSourcesTable">
                        <ScrollArea
                            :class="
                                (sourcesTableDataLoading && (sourcesTablePageSize || 10) <= 10) ||
                                (!sourcesTableDataLoading && (sourcesTableData?.length || 0) <= 10)
                                    ? 'h-auto'
                                    : 'h-70-dynamic'
                            "
                            class="w-full border shadow-md rounded-md">
                            <Table>
                                <TableHeader class="sticky top-0 bg-background z-10">
                                    <!-- Period headers row -->
                                    <TableRow class="bg-muted/50">
                                        <TableHead class="first:rounded-tl-md">Source Connector</TableHead>
                                        <template v-for="periodKey in selectedSourcesColumns" :key="periodKey">
                                            <TableHead
                                                class="text-center"
                                                :colspan="1"
                                                :class="{
                                                    'last:rounded-tr-md':
                                                        selectedSourcesColumns.indexOf(periodKey) === selectedSourcesColumns.length - 1
                                                }">
                                                {{ availableTimePeriods.find((p) => p.key === periodKey)?.label }}
                                            </TableHead>
                                        </template>
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    <!-- Skeleton rows when loading -->
                                    <template v-if="sourcesTableDataLoading">
                                        <TableRow v-for="n in sourcesTablePageSize || 10" :key="`sources-skeleton-${n}`">
                                            <TableCell><SkeletonLoader preset="table-name" :loading="true" /></TableCell>
                                            <TableCell v-for="period in selectedSourcesColumns" :key="`sources-skeleton-${period}`">
                                                <SkeletonLoader preset="table-metric" :loading="true" />
                                            </TableCell>
                                        </TableRow>
                                    </template>
                                    <!-- Actual data rows -->
                                    <template v-else>
                                        <TableRow v-for="(connectorMetrics, index) in sourcesTableData" :key="`sources-${index}`">
                                            <TableCell>
                                                <div class="flex items-center gap-2">
                                                    <Avatar class="h-6 w-6 bg-background dark:bg-slate-200 border border-border rounded-sm shrink-0">
                                                        <AvatarImage
                                                            :src="
                                                                getConnectorIcon(connectorMetrics.connector) ||
                                                                `/icons/${connectorMetrics.connector}.svg`
                                                            "
                                                            :alt="connectorMetrics.connector"
                                                            class="object-contain p-0.5" />
                                                        <AvatarFallback
                                                            class="bg-background dark:bg-slate-200 dark:text-slate-800 text-muted-foreground text-xs rounded-sm">
                                                            {{ connectorMetrics.connector?.charAt(0).toUpperCase() }}
                                                        </AvatarFallback>
                                                    </Avatar>
                                                    <Button
                                                        variant="link"
                                                        class="h-auto p-0 max-w-full text-left justify-start font-medium"
                                                        :title="connectorMetrics.name"
                                                        @click="$router.push(selectedSourceRouterPath(connectorMetrics.entity_id))">
                                                        <span class="truncate max-w-[200px] sm:max-w-[250px] md:max-w-[300px]">
                                                            {{ connectorMetrics.name }}
                                                        </span>
                                                    </Button>
                                                </div>
                                            </TableCell>
                                            <!-- Sources show only inboundBytes for each time period -->
                                            <TableCell
                                                v-for="periodKey in selectedSourcesColumns"
                                                :key="`sources-${index}-${periodKey}`"
                                                :variant="
                                                    sourcesTableDataLoading ||
                                                    (() => {
                                                        try {
                                                            const metricValue = getMetricFromPeriodKey(
                                                                connectorMetrics.metrics,
                                                                periodKey,
                                                                'inboundBytes'
                                                            );
                                                            let metricInfo = getMetricFormattingInfo(
                                                                'inboundBytes',
                                                                metricsStore.sources.globalConfigs?.metrics
                                                            );
                                                            if (!metricInfo) metricInfo = { unit: 'bytes', name: 'Inbound' };
                                                            return formatter(metricValue, metricInfo, false, () => false).display === '-';
                                                        } catch {
                                                            return true;
                                                        }
                                                    })()
                                                        ? 'default'
                                                        : 'metric-badge'
                                                ">
                                                <SkeletonLoader v-if="sourcesTableDataLoading" preset="inline-number" :loading="true" />
                                                <template v-else>
                                                    {{
                                                        (() => {
                                                            try {
                                                                const metricValue = getMetricFromPeriodKey(
                                                                    connectorMetrics.metrics,
                                                                    periodKey,
                                                                    'inboundBytes'
                                                                );
                                                                let metricInfo = getMetricFormattingInfo(
                                                                    'inboundBytes',
                                                                    metricsStore.sources.globalConfigs?.metrics
                                                                );
                                                                if (!metricInfo) metricInfo = { unit: 'bytes', name: 'Inbound' };
                                                                return formatter(metricValue, metricInfo, false, () => false).display;
                                                            } catch (error) {
                                                                console.error('Sources table formatter error:', error);
                                                                const metricValue = getMetricFromPeriodKey(
                                                                    connectorMetrics.metrics,
                                                                    periodKey,
                                                                    'inboundBytes'
                                                                );
                                                                return metricValue !== undefined ? `${metricValue} B` : '-';
                                                            }
                                                        })()
                                                    }}
                                                </template>
                                            </TableCell>
                                        </TableRow>
                                        <TableEmpty
                                            v-if="!sourcesTableDataLoading && (!sourcesTableData || sourcesTableData.length === 0)"
                                            :colspan="selectedSourcesColumns.length + 1">
                                            <TableEmptyState message="No source connectors found" />
                                        </TableEmpty>
                                    </template>
                                </TableBody>
                            </Table>
                            <ScrollBar orientation="horizontal" />
                            <ScrollBar orientation="vertical" />
                        </ScrollArea>

                        <TablePagination
                            v-if="sourcesTableTotal > sourcesTablePageSize || sourcesTablePage > 0"
                            :current-page="sourcesTablePage"
                            :page-size="sourcesTablePageSize"
                            :current-page-items-count="sourcesTableData?.length || 0"
                            :loading="globalSourceConfigsLoading || sourcesTableDataLoading"
                            :total-items="sourcesTableTotal"
                            item-type="source connectors"
                            :show-items-per-page="true"
                            @page-change="(page) => fetchSourcesTableData(page, null, null, selectedTenantIds?.value || [])"
                            @page-size-change="(newSize) => fetchSourcesTableData(0, newSize, null, selectedTenantIds?.value || [])" />
                    </div>
                </div>

                <!-- Destinations Table Section -->
                <div class="space-y-4 mt-8 bg-card rounded-lg border p-4">
                    <!-- Destinations Table Header -->
                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-3">
                            <h4 class="text-lg font-medium">Destinations - Outbound</h4>
                        </div>
                        <div class="flex items-center gap-4">
                            <ActionMenu
                                variant="row"
                                :show-export-usage="true"
                                :loading="destinationsExportLoading"
                                :disable-export-usage="
                                    destinationsTableDataLoading ||
                                    globalDestinationConfigsLoading ||
                                    destinationsExportLoading
                                "
                                :buttons-size="'xs'"
                                @export-usage="downloadDestinationsUsage(selectedTenantIds?.value || [])" />
                            <div class="flex items-center gap-2">
                                <span class="text-sm text-muted-foreground">Show table:</span>
                                <label for="show-destinations" class="flex items-center gap-2">
                                    <Checkbox v-model="showDestinationsTable" id="show-destinations" />
                                    <span class="text-sm">Visible</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    <!-- Destinations Controls -->
                    <div v-if="showDestinationsTable" class="space-y-4">
                        <!-- Search and Column Selection -->
                        <div class="flex flex-col sm:flex-row gap-4">
                            <div class="flex-1">
                                <SearchInput
                                    :loading="destinationsTableDataLoading"
                                    placeholder="Search destinations..."
                                    @search="
                                        (input) => {
                                            destinationsSearchQuery = input;
                                            onDestinationsSearchInput(input);
                                        }
                                    " />
                            </div>
                            <div class="min-w-64">
                                <MultiSelect
                                    v-model="selectedDestinationsColumns"
                                    :options="destinationsColumnOptions"
                                    placeholder="Select columns"
                                    :show-tags="true"
                                    :show-select-all="true" />
                            </div>
                        </div>
                    </div>

                    <!-- Destinations Table -->
                    <div v-if="showDestinationsTable">
                        <ScrollArea
                            :class="
                                (destinationsTableDataLoading && (destinationsTablePageSize || 10) <= 10) ||
                                (!destinationsTableDataLoading && (destinationsTableData?.length || 0) <= 10)
                                    ? 'h-auto'
                                    : 'h-70-dynamic'
                            "
                            class="w-full border shadow-md rounded-md">
                            <Table>
                                <TableHeader class="sticky top-0 bg-background z-10">
                                    <!-- Period headers row -->
                                    <TableRow class="bg-muted/50">
                                        <TableHead class="first:rounded-tl-md">Destination Connector</TableHead>
                                        <template v-for="periodKey in selectedDestinationsColumns" :key="periodKey">
                                            <TableHead
                                                class="text-center"
                                                :colspan="1"
                                                :class="{
                                                    'last:rounded-tr-md':
                                                        selectedDestinationsColumns.indexOf(periodKey) === selectedDestinationsColumns.length - 1
                                                }">
                                                {{ availableTimePeriods.find((p) => p.key === periodKey)?.label }}
                                            </TableHead>
                                        </template>
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    <!-- Skeleton rows when loading -->
                                    <template v-if="destinationsTableDataLoading">
                                        <TableRow v-for="n in destinationsTablePageSize || 10" :key="`destinations-skeleton-${n}`">
                                            <TableCell><SkeletonLoader preset="table-name" :loading="true" /></TableCell>
                                            <TableCell v-for="period in selectedDestinationsColumns" :key="`destinations-skeleton-${period}`">
                                                <SkeletonLoader preset="table-metric" :loading="true" />
                                            </TableCell>
                                        </TableRow>
                                    </template>
                                    <!-- Actual data rows -->
                                    <template v-else>
                                        <TableRow v-for="(connectorMetrics, index) in destinationsTableData" :key="`destinations-${index}`">
                                            <TableCell>
                                                <div class="flex items-center gap-2">
                                                    <Avatar class="h-6 w-6 bg-background dark:bg-slate-200 border border-border rounded-sm shrink-0">
                                                        <AvatarImage
                                                            :src="
                                                                getConnectorIcon(connectorMetrics.connector) ||
                                                                `/icons/${connectorMetrics.connector}.svg`
                                                            "
                                                            :alt="connectorMetrics.connector"
                                                            class="object-contain p-0.5" />
                                                        <AvatarFallback
                                                            class="bg-background dark:bg-slate-200 dark:text-slate-800 text-muted-foreground text-xs rounded-sm">
                                                            {{ connectorMetrics.connector?.charAt(0).toUpperCase() }}
                                                        </AvatarFallback>
                                                    </Avatar>
                                                    <Button
                                                        variant="link"
                                                        class="h-auto p-0 max-w-full text-left justify-start font-medium"
                                                        :title="connectorMetrics.name"
                                                        @click="$router.push(selectedDestinationRouterPath(connectorMetrics.entity_id))">
                                                        <span class="truncate max-w-[200px] sm:max-w-[250px] md:max-w-[300px]">
                                                            {{ connectorMetrics.name }}
                                                        </span>
                                                    </Button>
                                                </div>
                                            </TableCell>
                                            <!-- Destinations show only outboundBytes for each time period -->
                                            <TableCell
                                                v-for="periodKey in selectedDestinationsColumns"
                                                :key="`destinations-${index}-${periodKey}`"
                                                :variant="
                                                    destinationsTableDataLoading ||
                                                    (() => {
                                                        try {
                                                            const metricValue = getMetricFromPeriodKey(
                                                                connectorMetrics.metrics,
                                                                periodKey,
                                                                'outboundBytes'
                                                            );
                                                            let metricInfo = getMetricFormattingInfo(
                                                                'outboundBytes',
                                                                metricsStore.destinations.globalConfigs?.metrics
                                                            );
                                                            if (!metricInfo) metricInfo = { unit: 'bytes', name: 'Outbound' };
                                                            return formatter(metricValue, metricInfo, false, () => false).display === '-';
                                                        } catch {
                                                            return true;
                                                        }
                                                    })()
                                                        ? 'default'
                                                        : 'metric-badge'
                                                ">
                                                <SkeletonLoader v-if="destinationsTableDataLoading" preset="inline-number" :loading="true" />
                                                <template v-else>
                                                    {{
                                                        (() => {
                                                            try {
                                                                const metricValue = getMetricFromPeriodKey(
                                                                    connectorMetrics.metrics,
                                                                    periodKey,
                                                                    'outboundBytes'
                                                                );
                                                                let metricInfo = getMetricFormattingInfo(
                                                                    'outboundBytes',
                                                                    metricsStore.destinations.globalConfigs?.metrics
                                                                );
                                                                if (!metricInfo) metricInfo = { unit: 'bytes', name: 'Outbound' };
                                                                return formatter(metricValue, metricInfo, false, () => false).display;
                                                            } catch (error) {
                                                                console.error('Destinations table formatter error:', error);
                                                                const metricValue = getMetricFromPeriodKey(
                                                                    connectorMetrics.metrics,
                                                                    periodKey,
                                                                    'outboundBytes'
                                                                );
                                                                return metricValue !== undefined ? `${metricValue} B` : '-';
                                                            }
                                                        })()
                                                    }}
                                                </template>
                                            </TableCell>
                                        </TableRow>
                                        <TableEmpty
                                            v-if="!destinationsTableDataLoading && (!destinationsTableData || destinationsTableData.length === 0)"
                                            :colspan="selectedDestinationsColumns.length + 1">
                                            <TableEmptyState message="No destination connectors found" />
                                        </TableEmpty>
                                    </template>
                                </TableBody>
                            </Table>
                            <ScrollBar orientation="horizontal" />
                            <ScrollBar orientation="vertical" />
                        </ScrollArea>

                        <TablePagination
                            v-if="destinationsTableTotal > destinationsTablePageSize || destinationsTablePage > 0"
                            :current-page="destinationsTablePage"
                            :page-size="destinationsTablePageSize"
                            :current-page-items-count="destinationsTableData?.length || 0"
                            :loading="globalDestinationConfigsLoading || destinationsTableDataLoading"
                            :total-items="destinationsTableTotal"
                            item-type="destination connectors"
                            :show-items-per-page="true"
                            @page-change="(page) => fetchDestinationsTableData(page, null, null, selectedTenantIds?.value || [])"
                            @page-size-change="(newSize) => fetchDestinationsTableData(0, newSize, null, selectedTenantIds?.value || [])" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import _ from 'lodash';
import PageBreadcrumb from '../../components/PageBreadcrumb.vue';
import { computed, ref, onBeforeMount, watch } from 'vue';
import TimeRangeFilter from '@/components/filters/TimeRangeFilter.vue';
import HighChart from '../../components/HighChart.vue';
import StatCard from '../../components/global/StatCard.vue';
import { formatter, getMetricFormattingInfo, isJSON, formatChartXAxisLabels } from '../../utils/utils';
import { useMetricsStore } from '../../stores/metrics.store';
import { FILTER_DEFAULTS, TIME_RANGE_LABELS } from '../../utils/constants';
import { getTimeRangeLabel, createDateFilterFromTimeRange, convertFilterKeyToTimeRangeValue, getDatesBasedOnFilter } from '../../utils/utils';
import moment from 'moment-timezone';
import { MultiSelect } from '@/components/ui/multi-select';
import TablePagination from '@/components/TablePagination.vue';
import SearchInput from '@/components/global/SearchInput.vue';
import ActionMenu from '../../components/ActionMenu.vue';
import BillingTenantSelector from '../../components/BillingTenantSelector.vue';
import { SkeletonLoader } from '@/components/ui/skeleton-loader';
import { getConnectorIcon } from '@/utils/constants';
import { Badge } from '@/components/ui/badge';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { useUrlFilters } from '@/composables/useUrlFilters';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { useFrontegg } from '@frontegg/vue';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow, TableEmpty } from '@/components/ui/table';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';
import { Button } from '@/components/ui/button';
import { TableEmptyState } from '@/components/ui/table-empty-state';
import { Checkbox } from '@/components/ui/checkbox';

const metricsStore = useMetricsStore();
const frontegg = useFrontegg();

// Setup URL filters composable
const { registerFilter, resetAllFilters } = useUrlFilters({
    defaults: {
        selectedBillingTimeseriesDateFilter: { key: FILTER_DEFAULTS.DATE_FILTERS.LAST_24H },
        selectedTenantIds: null,
        allSelectedMetricsForBillingChart: []
    },
    serializers: {
        selectedBillingTimeseriesDateFilter: (value) => JSON.stringify(value),
        selectedTenantIds: (value) => (value ? JSON.stringify(value) : null),
        allSelectedMetricsForBillingChart: (value) => JSON.stringify(value)
    },
    deserializers: {
        selectedBillingTimeseriesDateFilter: (value) => {
            try {
                return JSON.parse(value);
            } catch {
                return { key: FILTER_DEFAULTS.DATE_FILTERS.LAST_24H };
            }
        },
        selectedTenantIds: (value) => {
            try {
                return JSON.parse(value);
            } catch {
                return null;
            }
        },
        allSelectedMetricsForBillingChart: (value) => {
            try {
                return value ? JSON.parse(value) : [];
            } catch {
                return [];
            }
        }
    }
});

// Register filters and get reactive references
const selectedBillingTimeseriesDateFilter = registerFilter('selectedBillingTimeseriesDateFilter');
const allSelectedMetricsForBillingChart = registerFilter('allSelectedMetricsForBillingChart');

// Define time periods for column selection
const availableTimePeriods = [
    { key: '1-hours', label: '1 Hour' },
    { key: '1-days', label: '1 Day' },
    { key: '7-days', label: '7 Days' },
    { key: '30-days', label: '30 Days' },
    { key: '90-days', label: '90 Days' },
    { key: '365-days', label: '365 Days' }
];

const availableMetrics = [
    { key: 'byteTotal', label: 'Inbound' },
    { key: 'outboundBytes', label: 'Outbound' },
    { key: 'billableBytes', label: 'Billable' }
];

const selectedBillingMetricKeys = computed({
    get() {
        return allSelectedMetricsForBillingChart.value.map((metric) => metric.key);
    },
    set(keys) {
        allSelectedMetricsForBillingChart.value = keys.map((key) => listOfBillingMetrics.value.find((metric) => metric.key === key)).filter(Boolean);
    }
});

const selectedTenantIds = registerFilter('selectedTenantIds');

// Auto-select current user's tenant if none is selected
watch(
    () => frontegg?.user?.tenantId,
    async (tenantId) => {
        if (!selectedTenantIds.value && tenantId) {
            selectedTenantIds.value = [tenantId];
            // Trigger initial data fetch for the selected tenant
            await generalFetchOfTheBillingPage([tenantId]);
        }
    },
    { immediate: true }
);

// Usage stats for StatCard components
const usageStats = computed(() => {
    const periods = [
        { key: '1-hours', label: '1 HOUR', id: 1 },
        { key: '1-days', label: '1 DAY', id: 2 },
        { key: '7-days', label: '7 DAYS', id: 3 },
        { key: '30-days', label: '30 DAYS', id: 4 },
        { key: '90-days', label: '90 DAYS', id: 5 },
        { key: '365-days', label: '365 DAYS', id: 6 }
    ];

    const metricTypes = [
        { key: 'billableBytes', label: 'billable' },
        { key: 'byteTotal', label: 'inbound' },
        { key: 'outboundBytes', label: 'outbound' }
    ];

    const result = {};

    metricTypes.forEach(({ key: metricKey, label: metricLabel }) => {
        result[metricLabel] = periods.map((period) => {
            // Get metric formatting info with fallback

            // Try sources first, then destinations, then provide fallback
            let metricInfo = getMetricFormattingInfo(metricKey, metricsStore.sources.globalConfigs?.metrics);

            if (!metricInfo) {
                metricInfo = getMetricFormattingInfo(metricKey, metricsStore.destinations.globalConfigs?.metrics);
            }

            if (!metricInfo) {
                // Provide fallback formatting for these specific metrics
                const fallbackConfigs = {
                    byteTotal: { unit: 'bytes', name: 'Inbound Data' },
                    outboundBytes: { unit: 'bytes', name: 'Outbound Data' },
                    billableBytes: { unit: 'bytes', name: 'Billable Data' }
                };
                metricInfo = fallbackConfigs[metricKey];
            }

            // Use helper function to get metric value from summary data
            const rawMetricsData = metricsStore.organization.usageSummaryData.metrics;
            const metricValue = getMetricFromPeriodKey(rawMetricsData, period.key, metricKey);

            const shouldFormat = metricInfo && (metricValue === 0 || (metricValue !== undefined && metricValue !== null));
            let displayValue = '-';

            if (shouldFormat) {
                try {
                    const formatted = formatter(metricValue, metricInfo, false, () => false);
                    displayValue = formatted.display;
                } catch (error) {
                    console.error('Formatter error for', metricKey, ':', error);
                    displayValue = `${metricValue} ${metricInfo.unit || 'B'}`;
                }
            }

            return {
                id: `${metricLabel}-${period.id}`,
                name: period.label,
                value: displayValue,
                loading: organisationUsageSummaryLoading.value
            };
        });
    });

    return result;
});

const orgStatisticsLoading = ref(false);
const timeseriesLoading = ref(false);
const globalSourceConfigsLoading = ref(false);
const globalDestinationConfigsLoading = ref(false);
const organisationUsageSummaryLoading = ref(false);
const usageDownloadLoading = ref(false);
const sourcesExportLoading = ref(false);
const destinationsExportLoading = ref(false);
const isInitializing = ref(true);

const billingTimeseriesData = ref([]);

// Separate data for Sources and Destinations tables
const sourcesTableData = ref([]);
const destinationsTableData = ref([]);
const sourcesTableDataLoading = ref(false);
const destinationsTableDataLoading = ref(false);

// Table pagination states

const sourcesTablePage = ref(0);
const sourcesTablePageSize = ref(10);
const sourcesTableTotal = ref(0);

const destinationsTablePage = ref(0);
const destinationsTablePageSize = ref(10);
const destinationsTableTotal = ref(0);

// Table visibility toggles
const showSourcesTable = ref(true);
const showDestinationsTable = ref(true);

// Separate column selections for each table
const selectedSourcesColumns = ref(['1-hours', '1-days', '7-days']);

const selectedDestinationsColumns = ref(['1-hours', '1-days', '7-days']);

// Column options for each table's MultiSelect
const sourcesColumnOptions = computed(() => {
    return availableTimePeriods.map((period) => ({
        value: period.key,
        label: period.label
    }));
});

const destinationsColumnOptions = computed(() => {
    return availableTimePeriods.map((period) => ({
        value: period.key,
        label: period.label
    }));
});

const sourcesSearchQuery = ref(null);
const destinationsSearchQuery = ref(null);

onBeforeMount(async () => {
    await generalFetchOfTheBillingPage();
});

const generalFetchOfTheBillingPage = async (tenantIds = []) => {
    orgStatisticsLoading.value = true;
    timeseriesLoading.value = true;
    sourcesTableDataLoading.value = true;
    destinationsTableDataLoading.value = true;
    globalSourceConfigsLoading.value = true;
    globalDestinationConfigsLoading.value = true;
    organisationUsageSummaryLoading.value = true;

    // Use current filter values from composable
    const currentTenantIds = tenantIds.length ? tenantIds : selectedTenantIds.value;

    try {
        await Promise.all([
            metricsStore.sources.fetchGlobalSourceConfigs().then(() => {
                globalSourceConfigsLoading.value = false;
            }),
            metricsStore.destinations.fetchGlobalDestinationConfigs(() => {
                globalDestinationConfigsLoading.value = false;
            }),
            metricsStore.organization.fetchOrganisationUsageSummary(tenantIds).then(() => {
                organisationUsageSummaryLoading.value = false;
            }),
            fetchSourcesTableData(0, 10, null, currentTenantIds),
            fetchDestinationsTableData(0, 10, null, currentTenantIds),
            fetchBillingTimeseries(selectedBillingTimeseriesDateFilter.value, currentTenantIds)
        ]);
    } catch (error) {
        console.error('Billing page error:', error);
    } finally {
        orgStatisticsLoading.value = false;
        timeseriesLoading.value = false;
        sourcesTableDataLoading.value = false;
        destinationsTableDataLoading.value = false;
        globalDestinationConfigsLoading.value = false;
        globalSourceConfigsLoading.value = false;
        organisationUsageSummaryLoading.value = false;
        isInitializing.value = false;
    }

    return true;
};

const onSelectedTenantChange = async (tenantIds) => {
    if (_.isEqual(tenantIds, selectedTenantIds.value)) {
        return;
    }

    // Clear all filters and reset to defaults when tenant changes
    resetAllFilters();
    selectedTenantIds.value = tenantIds;

    await new Promise((resolve) => setTimeout(resolve, 200));

    sourcesSearchQuery.value = '';
    destinationsSearchQuery.value = '';
    metricsStore.organization.setUsagePageNumber(0);
    metricsStore.organization.setUsagePageSize(10);

    await generalFetchOfTheBillingPage(selectedTenantIds.value);
};

const onSourcesSearchInput = _.debounce(async (input) => {
    // Search sources table when sources search query changes
    await fetchSourcesTableData(null, null, input, selectedTenantIds?.value || []);
}, 700);

const onDestinationsSearchInput = _.debounce(async (input) => {
    // Search destinations table when destinations search query changes
    await fetchDestinationsTableData(null, null, input, selectedTenantIds?.value || []);
}, 700);

const downloadUsage = async (tenantIds = [], entity_type = null, loadingRef = null) => {
    if (loadingRef) {
        loadingRef.value = true;
    }
    try {
        let usageExportText = await metricsStore.organization.exportUsage(tenantIds, entity_type);

        if (isJSON(usageExportText) && typeof usageExportText === 'object') {
            usageExportText = JSON.stringify(usageExportText, null, 2);
        }

        const blob = new Blob([usageExportText], { type: 'text/plain' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');

        // Generate filename based on entity_type and tenantIds
        let filename = 'streamkap_usage';
        if (entity_type) {
            filename += `_${entity_type}`;
        }
        if (tenantIds?.length) {
            filename += `_tenant_${tenantIds.join('__')}`;
        }
        filename += '.csv';

        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
    } catch (err) {
        console.error('Billing error:', err);
    } finally {
        if (loadingRef) {
            loadingRef.value = false;
        }
    }
};

const downloadSourcesUsage = async (tenantIds = []) => {
    await downloadUsage(tenantIds, 'sources', sourcesExportLoading);
};

const downloadDestinationsUsage = async (tenantIds = []) => {
    await downloadUsage(tenantIds, 'destinations', destinationsExportLoading);
};

const listOfBillingMetrics = computed(() => {
    let sourceMetricsKeys = Object.keys(billingTimeseriesData.value?.sources?.account?.billing || {});
    let destinationMetricsKeys = Object.keys(billingTimeseriesData.value?.destinations?.account?.billing || {});

    // Fallback configs for metrics that might not be in global configs
    const fallbackConfigs = {
        byteTotal: { unit: 'bytes', name: 'Inbound Data' },
        outboundBytes: { unit: 'bytes', name: 'Outbound Data' },
        billableBytes: { unit: 'bytes', name: 'Billable Data' },
        bytesConsumedTotal: { unit: 'bytes', name: 'Consumed Data' },
        recordsConsumedTotal: { unit: 'count', name: 'Records Consumed' }
    };

    sourceMetricsKeys = sourceMetricsKeys
        .map((key) => {
            let metricInfo = getMetricFormattingInfo(key, metricsStore.sources.globalConfigs?.metrics);

            if (!metricInfo) {
                metricInfo = fallbackConfigs[key];
            }

            if (!metricInfo) {
                return null;
            }

            return {
                ...metricInfo,
                key,
                type: 'source',
                name: `Sources - ${metricInfo.name}`
            };
        })
        .filter((x) => x && billingTimeseriesData.value?.sources?.account?.billing?.[x.key]?.length);

    destinationMetricsKeys = destinationMetricsKeys
        .map((key) => {
            let metricInfo = getMetricFormattingInfo(key, metricsStore.destinations.globalConfigs?.metrics);

            if (!metricInfo) {
                metricInfo = fallbackConfigs[key];
            }

            if (!metricInfo) {
                return null;
            }

            return {
                ...metricInfo,
                key,
                type: 'destination',
                name: `Destinations - ${metricInfo.name}`
            };
        })
        .filter((x) => x && billingTimeseriesData.value?.destinations?.account?.billing?.[x.key]?.length);

    const keysToReturn = [...sourceMetricsKeys, ...destinationMetricsKeys];

    return _.orderBy(keysToReturn, 'name', 'asc');
});

// Separate computed for just tracking metric keys (for watcher optimization)
const availableBillingMetricKeys = computed(() => {
    return listOfBillingMetrics.value.map((m) => m.key).sort();
});

// Watch for changes in available billing metrics and set defaults
watch(
    () => listOfBillingMetrics.value,
    (newValue) => {
        const defaultTo = ['byteTotal', 'outboundBytes', 'bytesConsumedTotal'];

        // If no metrics are selected yet, select available defaults
        if (!allSelectedMetricsForBillingChart.value.length && newValue.length) {
            const availableDefaults = newValue.filter((x) => defaultTo.includes(x.key));
            allSelectedMetricsForBillingChart.value = availableDefaults.length ? availableDefaults : [newValue[0]];
        }
        // If some metrics are selected but we're missing default metrics that are now available, add them
        else if (allSelectedMetricsForBillingChart.value.length && newValue.length) {
            const currentSelectedKeys = allSelectedMetricsForBillingChart.value.map((m) => m.key);
            const missingDefaults = newValue.filter((metric) => defaultTo.includes(metric.key) && !currentSelectedKeys.includes(metric.key));

            if (missingDefaults.length) {
                allSelectedMetricsForBillingChart.value = [...allSelectedMetricsForBillingChart.value, ...missingDefaults];
            }
        }
    }
);

watch(
    () => availableBillingMetricKeys.value,
    (newKeys, oldKeys) => {
        // Don't run during initial component setup
        if (isInitializing.value) {
            return;
        }

        // Avoid infinite loops by checking if the keys actually changed
        if (JSON.stringify(newKeys) === JSON.stringify(oldKeys)) {
            return;
        }

        const defaultTo = ['byteTotal', 'outboundBytes', 'bytesConsumedTotal'];

        const availableMetrics = listOfBillingMetrics.value; // Get full metrics objects

        // Validate and clear invalid metrics to prevent crashes
        if (!newKeys?.length) {
            // No metrics available - clear selection
            if (allSelectedMetricsForBillingChart.value.length) {
                allSelectedMetricsForBillingChart.value = [];
            }
            return;
        }

        // Only set default metrics if none are selected
        if (!allSelectedMetricsForBillingChart.value.length && availableMetrics.length) {
            const defaultMetrics = availableMetrics.filter((x) => defaultTo.includes(x.key));
            allSelectedMetricsForBillingChart.value = defaultMetrics.length ? defaultMetrics : [availableMetrics[0]];
        }

        // If we have selected metrics, validate they still exist in available metrics
        else if (allSelectedMetricsForBillingChart.value.length && availableMetrics.length) {
            const validMetrics = allSelectedMetricsForBillingChart.value.filter((selected) =>
                availableMetrics.find((available) => available.key === selected.key)
            );

            // Only update if some metrics became invalid
            if (validMetrics.length !== allSelectedMetricsForBillingChart.value.length) {
                allSelectedMetricsForBillingChart.value = validMetrics;
            }
        }
    },
    { flush: 'post' } // Run after DOM updates to avoid timing issues
);

// Watch tenant changes - affects all billing data
watch(
    () => selectedTenantIds.value,
    async (newTenantIds, oldTenantIds) => {
        if (!isInitializing.value && newTenantIds !== oldTenantIds && oldTenantIds !== undefined) {
            await generalFetchOfTheBillingPage(newTenantIds || []);
        }
    }
);

// Watch date filter changes - only affects timeseries/chart data
watch(
    () => selectedBillingTimeseriesDateFilter.value,
    async (newDateFilter) => {
        if (!isInitializing.value && newDateFilter) {
            timeseriesLoading.value = true;
            await fetchBillingTimeseries(newDateFilter, selectedTenantIds?.value || []);
        }
    },
    { deep: true }
);

const fetchBillingTimeseries = async (specificDateFilter, tenantIds = []) => {
    timeseriesLoading.value = true;

    // Update filter if specific date filter is provided
    if (specificDateFilter) {
        selectedBillingTimeseriesDateFilter.value = specificDateFilter;
    }

    const currentDateFilter = selectedBillingTimeseriesDateFilter.value;
    const defaultDateFilter = currentDateFilter?.key === 'last24h' || !currentDateFilter || !currentDateFilter?.key;

    try {
        const timeseriesData = await metricsStore.organization.fetchBillingTimeseriesMetricsForAllConnectors(
            defaultDateFilter
                ? { tenant_ids: tenantIds }
                : {
                      start: currentDateFilter?.value?.start,
                      end: currentDateFilter?.value?.end,
                      tenant_ids: tenantIds
                  }
        );

        billingTimeseriesData.value = timeseriesData;

        return timeseriesData;
    } catch (err) {
        console.error('Billing error:', err);
    } finally {
        timeseriesLoading.value = false;
    }
};

// Helper function to get metric value from store's transformed metrics object based on period key
function getMetricFromPeriodKey(metricsData, periodKey, metricName) {
    if (!metricsData) return undefined;

    // If it's an array (raw API response), handle it the old way
    if (Array.isArray(metricsData)) {
        const periodMappings = {
            '1-hours': { time_unit: 'hours', time_interval: 1 },
            '1-days': { time_unit: 'days', time_interval: 1 },
            '7-days': { time_unit: 'days', time_interval: 7 },
            '30-days': { time_unit: 'days', time_interval: 30 },
            '90-days': { time_unit: 'days', time_interval: 90 },
            '365-days': { time_unit: 'days', time_interval: 365 }
        };

        const mapping = periodMappings[periodKey];
        if (!mapping) return undefined;

        const matchingMetric = metricsData.find((metric) => metric.time_unit === mapping.time_unit && metric.time_interval === mapping.time_interval);

        return matchingMetric ? matchingMetric[metricName] : undefined;
    }

    // If it's an object (store's transformed structure), access directly by key
    // Store uses format: "1-hours", "7-days", etc.
    const storeKey = periodKey; // Our periodKey format matches store's key format
    const metricObject = metricsData[storeKey];

    return metricObject ? metricObject[metricName] : undefined;
}

function selectedSourceRouterPath(id) {
    return { name: 'source-details', params: { id } };
}

function selectedDestinationRouterPath(id) {
    return { name: 'destination-details', params: { id } };
}

const chartOptions = computed(() => {
    const titleText = getTimeRangeLabel(selectedBillingTimeseriesDateFilter.value?.key) || TIME_RANGE_LABELS.LAST_24H;

    const metricKeys =
        _.cloneDeep(allSelectedMetricsForBillingChart.value)
            ?.map((x) => (x.key ? { key: x.key, type: x.type, name: x.name } : null))
            .filter((x) => x) || [];

    const dataForEachSelectedMetric = metricKeys
        .map(({ key, type, name }) => {
            const sourcesMetricData = billingTimeseriesData.value?.sources?.account?.billing[key];
            const destinationsMetricData = billingTimeseriesData.value?.destinations?.account?.billing[key];

            if (sourcesMetricData?.length && destinationsMetricData?.length) {
                return [
                    {
                        metricKey: key,
                        metricData: sourcesMetricData,
                        metricInfo: {
                            ...getMetricFormattingInfo(
                                key,
                                type === 'source' ? metricsStore.sources.globalConfigs?.metrics : metricsStore.destinations.globalConfigs?.metrics
                            ),
                            name
                        }
                    },
                    {
                        metricKey: key,
                        metricData: destinationsMetricData,
                        metricInfo: {
                            ...getMetricFormattingInfo(
                                key,
                                type === 'source' ? metricsStore.sources.globalConfigs?.metrics : metricsStore.destinations.globalConfigs?.metrics
                            ),
                            name
                        }
                    }
                ];
            }

            return {
                metricKey: key,
                metricData: sourcesMetricData || destinationsMetricData,
                metricInfo: {
                    ...getMetricFormattingInfo(
                        key,
                        type === 'source' ? metricsStore.sources.globalConfigs?.metrics : metricsStore.destinations.globalConfigs?.metrics
                    ),
                    name
                }
            };
        })
        .flat();

    const seriesAndYAxes = dataForEachSelectedMetric.map((metric, index) => {
        const yAxis = {
            title: {
                text: metric.metricInfo?.name
            },
            labels: {
                formatter: function () {
                    return formatter(this.value, { unit: metric.metricInfo?.unit }, false).display;
                }
            },
            opposite: index % 2 !== 0
        };

        const series = {
            name: metric.metricInfo?.name,
            data: metric.metricData?.map((dataItem) => {
                const localTime = moment.utc(dataItem.timestamp).tz(moment.tz.guess()).toDate();
                return {
                    x: localTime,
                    y: dataItem.value
                };
            }),
            type: 'line',
            yAxis: index,
            custom: {
                unit: metric.metricInfo?.unit
            },
            dataLabels: {
                enabled: true,
                formatter: function () {
                    return formatter(this.y, { unit: metric.metricInfo?.unit }, false).display;
                }
            }
        };

        return { series, yAxis };
    });

    // Split the series and yAxis configurations
    const series = seriesAndYAxes.map((sy) => sy.series);
    const yAxis = seriesAndYAxes.map((sy) => sy.yAxis);

    const options = {
        time: {
            timezone: moment.tz.guess()
        },
        chart: {
            zoomType: 'xy'
        },
        title: {
            text: titleText
        },
        subtitle: {
            text: (() => {
                const filterKey = selectedBillingTimeseriesDateFilter.value?.key || 'last24h';
                const dateRange = getDatesBasedOnFilter(filterKey);
                const timeUnit = dateRange.timeUnit || 'hour';
                return timeUnit === 'hour'
                    ? 'Hourly Data'
                    : timeUnit === 'minute'
                      ? 'Minute Data'
                      : timeUnit === 'month'
                        ? 'Monthly Data'
                        : 'Daily Data';
            })()
        },
        xAxis: {
            type: 'datetime',
            labels: {
                formatter: formatChartXAxisLabels
            }
        },
        yAxis: yAxis,
        series: series,
        tooltip: {
            shared: true,
            crosshairs: true,
            formatter: function () {
                const localTime = moment(new Date(this.x)).tz(moment.tz.guess()).format('YYYY-MM-DD HH:mm:ss');

                let tooltip = `${localTime}<br>`;
                this.points.forEach((point) => {
                    tooltip += `<b>${point.series.name}:</b> ${
                        formatter(point.y, { unit: point.series.userOptions.custom?.unit }, false).display
                    }<br>`;
                });
                return tooltip;
            }
        }
    };

    return options;
});

// Fetch Sources table data
async function fetchSourcesTableData(newPage = null, pageSize = null, currentSearchQuery = null, tenantIds = []) {
    sourcesTableDataLoading.value = true;

    try {
        sourcesTablePage.value = _.isNil(newPage) ? sourcesTablePage.value : newPage;
        sourcesTablePageSize.value = _.isNil(pageSize) ? sourcesTablePageSize.value : pageSize;

        if (currentSearchQuery || currentSearchQuery === '') {
            sourcesTablePage.value = 0;
        }

        const response = await metricsStore.organization.fetchOrganisationUsageMetrics({
            page_size: sourcesTablePageSize.value,
            page: sourcesTablePage.value,
            partial_name: currentSearchQuery || sourcesSearchQuery.value,
            tenant_ids: tenantIds,
            entity_type: 'sources'
        });

        // Process API response - always has { total, page_size, result } structure
        sourcesTableData.value =
            typeof response.result === 'object' && !Array.isArray(response.result) ? Object.values(response.result) : response.result || [];
        sourcesTableTotal.value = response.total || 0;
    } catch (error) {
        console.error('Error fetching sources table data:', error);
        sourcesTableData.value = [];
        sourcesTableTotal.value = 0;
    } finally {
        sourcesTableDataLoading.value = false;
    }
}

// Fetch Destinations table data
async function fetchDestinationsTableData(newPage = null, pageSize = null, currentSearchQuery = null, tenantIds = []) {
    destinationsTableDataLoading.value = true;

    try {
        destinationsTablePage.value = _.isNil(newPage) ? destinationsTablePage.value : newPage;
        destinationsTablePageSize.value = _.isNil(pageSize) ? destinationsTablePageSize.value : pageSize;

        if (currentSearchQuery || currentSearchQuery === '') {
            destinationsTablePage.value = 0;
        }

        const response = await metricsStore.organization.fetchOrganisationUsageMetrics({
            page_size: destinationsTablePageSize.value,
            page: destinationsTablePage.value,
            partial_name: currentSearchQuery || destinationsSearchQuery.value,
            tenant_ids: tenantIds,
            entity_type: 'destinations'
        });

        // Process API response - always has { total, page_size, result } structure
        destinationsTableData.value =
            typeof response.result === 'object' && !Array.isArray(response.result) ? Object.values(response.result) : response.result || [];
        destinationsTableTotal.value = response.total || 0;
    } catch (error) {
        console.error('Error fetching destinations table data:', error);
        destinationsTableData.value = [];
        destinationsTableTotal.value = 0;
    } finally {
        destinationsTableDataLoading.value = false;
    }
}

async function onTimeRangeChange(timeRangeValue) {
    const dateFilter = createDateFilterFromTimeRange(timeRangeValue);
    selectedBillingTimeseriesDateFilter.value = dateFilter;
    await fetchBillingTimeseries();
}
</script>

<style>
/* Custom CSS for aspect ratio */
.aspect-square {
    position: relative;
}
</style>
